import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-change-password",
  "use": "oc-change-password-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-change-password\"><path fill=\"#6B7180\" d=\"M9.833.625c1.282 0 2.33.997 2.412 2.258l.005.159v3.333h4.25v11h-15v-11h4.25V3.042c0-1.282.997-2.33 2.258-2.412l.159-.005h1.666ZM15 7.875H3v8h12v-8Zm-6 1.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm.833-8.75H8.167a.917.917 0 0 0-.91.81l-.007.107v3.333h3.5V3.042a.917.917 0 0 0-.81-.91l-.107-.007Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol